// External Dependencies
import React from 'react';
import { TableCell, TableHead, TableRow } from 'material-ui-next/Table';

const headerStyles = {
  paddingLeft: 16,
};

// Component Definition
const NinjasTableHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell padding="none">
        <span style={headerStyles}>Name</span>
      </TableCell>
      <TableCell>Title</TableCell>
      <TableCell>Last Attendance</TableCell>
      <TableCell>Badges</TableCell>
    </TableRow>
  </TableHead>
  );

export default NinjasTableHeader;



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/ninjas-table-header.js
 **/